import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import moment from 'moment-timezone';
import _ from 'lodash';
import qs from 'qs';
import {
  Checkbox,
  Form,
  Grid,
} from 'semantic-ui-react';
import { required, stringLength, email, identity as ValidateIdentity, phoneNumber, numericRange, matchRegex } from '@mhub/web-validations';
import { withTranslation } from 'react-i18next';
import AppForm from '../../components/AppForm';
import PhoneInput from '../../components/AppForm/PhoneInput';
import InputBirthdate from '../../components/InputBirthdate';
import { SELECT_COUNTRIES, SELECT_NATIONALITY } from '../../constants/countries';
import INTL_CALL_CODES from '../../constants/intlCallCodes';
import CUSTOMER_TITLES from '../../constants/customerTitles';
import TinFieldInput from '../../components/AppForm/TinFieldInput';
import STATES from '../../constants/states';
import { RACE } from '../../constants/race';
import { BUMI } from '../../constants/bumi';
import { GENDER } from '../../constants/gender';
import { MARITAL_STATUS } from '../../constants/maritalStatus';
import { REGEX_TIN_VALID, REGEX_NPWP_ID } from '../../constants/regex';
import { vnFullNameValidations, vnPreferredNameValidations } from '../../utils/vietnam';
import { fetchM } from '../../actions/fetchM';
import { flashMessage } from '../../actions/flash';
import config from '../../../config';
import dateFromIC from '../../utils/dateFromIC';
import { getItem } from '../../utils/storage';
import { getPhoneValidRegex } from '../../utils/validations/phone';
import { isForeignCompany } from '../../utils/companies';
import INTL_FLAG_CODES from '../../constants/intlFlagCodes';
import { getIdentityTypeOpts } from '../../utils/identityTypes';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { translateModels } from '../../utils/translation';
import { FOREIGN_BUYER_GENERIC_TIN, GENERIC_TIN_UNMATCHED_ERROR_MSG, GENERIC_TIN_VALUES, getAutoFillTin, getGenericTinByIdTypeAndTinNo, GOVERNMENT_GENERIC_TIN, isForeignIdType, isGenericTinFound } from '../../constants/tin';
import { IDENTITY_TYPE_BRN, IDENTITY_TYPE_NRIC } from '../../constants/defaultIdentityTypeOpts';

class CustomerForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.object,
    }),
    addressSettings: PropTypes.shape({
      data: PropTypes.array,
    }),
    customOptions: PropTypes.shape({
      data: PropTypes.array,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    identityTypeID: '',
    identity: '',
    identityPresetID: '',
    identityPresetLabel: '',
    identityPresetRegex: '',
    taxIdentificationNo: '',
    taxTinValidationStatus: '',
    title: '',
    name: '',
    preferredName: '',
    email: '',
    mobilePrefix: '60',
    mobile: '',
    phonePrefix: '60',
    phone: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    address5: '',
    address6: '',
    address7: '',
    address8: '',
    address9: '',
    address10: '',
    country: 'my',
    internalRemark: '',
    jobTitle: '',
    monthlyIncome: '',
    nationality: '',
    gender: '',
    race: '',
    raceOther: '',
    bumi: 'Not Applicable',
    maritalStatus: '',
    emergencyContactName: '',
    emergencyContactRelation: '',
    emergencyContactMobilePrefix: '60',
    emergencyContactMobile: '',
    emergencyContactEmail: '',
    emergencyContactIdentity: '',
    isForeignCompany: false,
  }
  constructor(props) {
    super(props);
    const customer = clone(CustomerForm.defaultValues);

    let identityPresets = {};
    const storeIdentityPresets = getItem(`${config.get('appName')}.identityPresets`);
    if (storeIdentityPresets) {
      try {
        identityPresets = JSON.parse(storeIdentityPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    const tinError = null;
    const auth = props.auth;
    const identityTypeOpts = getIdentityTypeOpts(auth, identityPresets);

    if (auth && isForeignCompany(auth.company)) {
      // Prefix & Country
      const idx = INTL_FLAG_CODES.findIndex(f => f.countryCode === auth.company.countryCode);
      if (idx !== -1) {
        const defaultCountryPhoneCode = INTL_FLAG_CODES[idx].value;
        customer.mobilePrefix = defaultCountryPhoneCode;
        customer.phonePrefix = defaultCountryPhoneCode;
        customer.emergencyContactMobilePrefix = defaultCountryPhoneCode;
        customer.country = INTL_FLAG_CODES[idx].countryCode;
      }
    }

    let phoneValidationPresets = {};
    const storePhoneValidationPresets = getItem(`${config.get('appName')}.phoneValidationPresets`);
    if (storePhoneValidationPresets) {
      try {
        phoneValidationPresets = JSON.parse(storePhoneValidationPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    this.validation = {
      country: createRef(),
      identity: createRef(),
      title: createRef(),
      name: createRef(),
      preferredName: createRef(),
      email: createRef(),
      mobilePrefix: createRef(),
      mobile: createRef(),
      phone: createRef(),
      monthlyIncome: createRef(),
      raceOther: createRef(),
      emergencyContactMobilePrefix: createRef(),
      emergencyContactMobile: createRef(),
      emergencyContactEmail: createRef(),
      taxIdentificationNo: createRef(),
    };

    // add validateRef for all enabled address settings
    const enabledAddressSettings = props.addressSettings.data.filter(as => as.enabled);
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach((as) => {
        const key = _.camelCase(as.columnName);
        this.validation[key] = createRef();
      });
    }

    let hideTitle = false;
    const customOptions = props.customOptions.data;
    if (customOptions.length > 0) {
      const hideTitleOpt = customOptions.find(o => o.name === 'hide_purchaser_title');
      if (hideTitleOpt) {
        hideTitle = hideTitleOpt.value === 'true';
      }
    }
    if (hideTitle) {
      customer.title = 'Not Applicable';
    }

    this.state = {
      customer,
      errMessages: [],
      tinMessage: null,
      identityTypeOpts,
      phoneValidationPresets,
      hideTitle,
      tinError,
      // flag to enable/disable tin searched using the lhdn api
      tinFound: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const { customer } = this.state;

    let hideTitle = false;
    const customOptions = nextProps.customOptions.data;
    if (customOptions.length > 0) {
      const hideTitleOpt = customOptions.find(o => o.name === 'hide_purchaser_title');
      if (hideTitleOpt) {
        hideTitle = hideTitleOpt.value === 'true';
      }
    }
    if (hideTitle) {
      customer.title = 'Not Applicable';
    }
    this.setState({
      customer,
      hideTitle,
    });
  }
  setLoading = (loading = false, loadingType) => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    }
  })
  getIdentityPlaceholder = (identityTypeID, identityLabel) => {
    const { t } = this.props;
    if (identityTypeID === '') {
      return `${t('Select Identity Type first')}*`;
    }
    if (typeof (identityTypeID) === 'string') {
      const { identityTypeOpts } = this.state;
      const idx = identityTypeOpts.findIndex(i => i.value === identityTypeID);
      if (idx !== -1) {
        return `${t('{{identity}} number', { identity: identityTypeOpts[idx].text })}*`;
      }
    }
    switch (identityTypeID) {
      case 2:
        return `${t('Passport Number')}*`;
      case 4:
        return `${t('Company Registration Number')}*`;
      case 6:
        return `${t('{{identity}} number', { identity: identityLabel })}*`;
      default:
        return `${t('Identity Number')}*`;
    }
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { customer, identityTypeOpts } = this.state;
    return AppForm.validate(this.validation, customer)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });

        if (customer.identityTypeID && typeof (customer.identityTypeID) === 'string') {
          let idx = -1;
          if (identityTypeOpts && identityTypeOpts.length > 0) {
            idx = identityTypeOpts.findIndex(i => i.value === customer.identityTypeID);
          }
          if (idx !== -1) {
            customer.identityTypeID = 6;
            customer.identityPresetID = identityTypeOpts[idx].value;
            customer.identityPresetLabel = identityTypeOpts[idx].text;
            customer.identityPresetRegex = identityTypeOpts[idx]['data-regex'];
          }
        }
        const { store } = this.context;
        customer.taxTinValidationStatus = this.state.tinError === false ? 'success' : 'failed';
        if (customer.taxTinValidationStatus !== 'success' && customer.identityTypeID === IDENTITY_TYPE_BRN && !customer.isForeignCompany) {
          store.dispatch(flashMessage({
            header: 'Invalid TIN',
            message: 'Tax Identification Number is invalid',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000,
          }));
          return;
        }

        const customerDetail = {
          title: this.state.hideTitle ? 'Not Applicable' : customer.title,
          name: customer.name,
          preferredName: customer.preferredName,
          email: customer.email,
          mobilePrefix: customer.mobilePrefix,
          mobile: customer.mobile,
          phonePrefix: customer.phonePrefix,
          phone: customer.phone,
          address1: customer.address1,
          address2: customer.address2,
          address3: customer.address3,
          address4: customer.address4,
          address5: customer.address5,
          address6: customer.address6,
          address7: customer.address7,
          address8: customer.address8,
          address9: customer.address9,
          address10: customer.address10,
          country: customer.country,
          jobTitle: customer.jobTitle,
          monthlyIncome: parseFloat(customer.monthlyIncome),
          nationality: customer.nationality,
          birthdate: customer.birthdate,
          gender: customer.gender,
          race: customer.race.toUpperCase() === 'Others'.toUpperCase() ? customer.raceOther : customer.race,
          bumi: customer.bumi,
          maritalStatus: customer.maritalStatus,
          emergencyContactName: customer.emergencyContactName,
          emergencyContactRelation: customer.emergencyContactRelation,
          emergencyContactMobilePrefix: customer.emergencyContactMobilePrefix,
          emergencyContactMobile: customer.emergencyContactMobile,
          emergencyContactEmail: customer.emergencyContactEmail,
          emergencyContactIdentity: customer.emergencyContactIdentity,
        };
        const postCustomer = {
          customerDetail,
          identityTypeID: customer.identityTypeID,
          identity: customer.identity,
          identityPresetID: customer.identityPresetID,
          identityPresetLabel: customer.identityPresetLabel,
          identityPresetRegex: customer.identityPresetRegex,
          taxIdentificationNo: customer.taxIdentificationNo,
          taxTinValidationStatus: customer.taxTinValidationStatus,
          internalRemark: customer.internalRemark,
          isForeignCompany: customer.isForeignCompany,
        };
        this.props.onSubmit(validations, postCustomer);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleChange = (event, value) => {
    const { auth } = this.props;
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const { customer } = this.state;
    customer[value.name] = value.value;
    if (value.name === 'race' && customer.race.toUpperCase() !== 'Others'.toUpperCase()) {
      customer.raceOther = '';
    }
    if (value.name === 'identity' && customer.identityTypeID === IDENTITY_TYPE_NRIC && value.value.length === 12) {
      const dfIC = dateFromIC(value.value.substring(0, 6));
      if (dfIC) {
        const mBirthdate = moment.tz(dfIC, config.get('tzName'));
        if (mBirthdate.isValid()) {
          customer.birthdate = mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    if (value.name === 'identityTypeID' && value.value === IDENTITY_TYPE_BRN) {
      customer.title = 'Not Applicable';
      customer.nationality = 'Not Applicable';
      customer.gender = 'Not Applicable';
      customer.race = 'Not Applicable';
      customer.bumi = 'Not Applicable';
      customer.maritalStatus = 'Not Applicable';
      customer.birthdate = '';
    } else if (value.name === 'identityTypeID' && (value.value !== IDENTITY_TYPE_BRN) && customer.title === 'Not Applicable') {
      customer.title = this.state.hideTitle ? 'Not Applicable' : '';
      customer.nationality = '';
      customer.gender = '';
      customer.race = '';
      customer.bumi = 'Not Applicable';
      customer.maritalStatus = '';
    }
    if (isMalaysia) {
      if (value.name === 'identityTypeID') {
        customer.isForeignCompany = false;
        customer.taxIdentificationNo = getAutoFillTin(customer.identityTypeID, customer.isForeignCompany);
      }
    }
    this.setState({ customer, tinMessage: null, tinError: false, tinFound: false }, () => {
      // Validate value again on identityTypeID change
      if (value.name === 'identityTypeID') {
        // Validate identity
        if (this.validation.identity && this.validation.identity.current && customer.identity !== '') {
          this.validation.identity.current.validate(customer.identity);
        }

        // Validate pref name | contact persion
        if (this.validation.preferredName && this.validation.preferredName.current && customer.preferredName !== '') {
          this.validation.preferredName.current.validate(customer.preferredName);
        }
        // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
        if (this.validation.name && this.validation.name.current && customer.name !== '') {
          this.validation.name.current.validate(customer.name);
        }
        if (customer.taxIdentificationNo !== '') {
          this.handleTinInput({ target: { value: customer.taxIdentificationNo } });
        }
      }
      if (value.name === 'identity' && customer.taxIdentificationNo !== '') {
        this.handleTinInput({ target: { value: customer.taxIdentificationNo } });
      }
      // Validate mobile on prefix change
      if (this.validation.mobile && this.validation.mobile.current && value.name === 'mobilePrefix') {
        this.validation.mobile.current.validate(customer.mobile);
      }
      // Validate phone on prefix change
      if (this.validation.phone && this.validation.phone.current && value.name === 'phonePrefix') {
        this.validation.phone.current.validate(customer.phone);
      }
      this.handleCheckChanges();
    });
  }
  handleBirthdateSelect = (day) => {
    const { customer } = this.state;
    customer.birthdate = day;
    this.setState({ customer });
  }
  handleTinInput = (e) => {
    const { customer } = this.state;
    const { auth } = this.props;
    const isIndonesia = auth && auth.company && auth.company.countryCode && auth.company.countryCode.toUpperCase() === 'ID';
    if (isIndonesia) {
      customer.taxIdentificationNo = e.target.value;
      this.setState({ customer }, () => {
        this.handleCheckChanges();
      });
      return;
    }

    const tinInput = e.target.value.toUpperCase();
    const tinFound = e.target.tinFound;
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      customer.taxIdentificationNo = '';
      this.setState({ customer, tinFound: false, tinError: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      customer.taxIdentificationNo = tinInput;
      this.setState({ customer, tinFound, tinError: tinFound === false, tinMessage: this.state.tinMessage }, () => {
        this.handleCheckChanges();
      });
      if (tinFound) {
        return;
      }
      // 1~2 letter followed by numeric with length 9 - 11
      const matched = REGEX_TIN_VALID.test(tinInput);
      const genericTin = getGenericTinByIdTypeAndTinNo(customer.identityTypeID, tinInput, customer.isForeignCompany);
      this.setLoading(true, 'validatingTIN').then(() => {
        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout);
        }
        this.debounceTimeout = setTimeout(() => {
          if (matched) {
            if (tinInput === GOVERNMENT_GENERIC_TIN) {
              const isForeign = !isForeignIdType(customer.identityTypeID, customer.identityTypeID === IDENTITY_TYPE_BRN && customer.isForeignCompany);
              this.setState({
                tinError: !isForeign,
                tinFound: !isForeign,
                tinMessage: !isForeign ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
              () => {
                this.setLoading(false, 'validatingTIN');
              });
            } else if (GENERIC_TIN_VALUES.includes(tinInput)) {
              this.setState({
                tinError: !isGenericTinFound(genericTin),
                tinFound: isGenericTinFound(genericTin),
                tinMessage: !isGenericTinFound(genericTin) ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
              () => {
                this.setLoading(false, 'validatingTIN');
              });
            } else {
              this.validateTIN(tinInput).finally(() => {
                this.setLoading(false, 'validatingTIN');
              });
            }
          } else {
            this.setState({ tinError: true }, () => {
              this.setLoading(false, 'validatingTIN');
            });
          }
        }, 3000);
      });
    }
  };

  async validateTIN(tinInput) {
    const { identityTypeID, identity } = this.state.customer;
    if (!tinInput || !identityTypeID || !identity) {
      return;
    }
    const idType = getIdentityTypeOpts().find(i => i.value === identityTypeID).tin_code;
    const query = Object.assign({
      tin: tinInput,
      idType,
      idValue: identity,
    });
    const { store } = this.context;
    try {
      const res = await store.dispatch(fetchM(`/tin/validate/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Origin': this.state.origin,
        },
      }));

      if (res && res.ok) {
        this.setState({
          tinError: false,
          tinFound: true,
          tinMessage: null,
        });
      } else {
        const errorMessage = await res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
        return;
      }
    } catch (err) {
      if (err.res) {
        const errorMessage = await err.res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
      }
    }
  }
  validateIdentityType = () => {
    const identityType = this.state.customer.identityTypeID;
    switch (identityType) {
      case 1:
        return 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  }
  identityValidation = () => {
    const { customer, identityTypeOpts } = this.state;
    if (customer.identityTypeID === 6 || typeof (customer.identityTypeID) === 'string') {
      const idx = identityTypeOpts.findIndex(i => i.value === customer.identityTypeID);
      let regex = '';
      if (idx !== -1) {
        regex = identityTypeOpts[idx]['data-regex'];
      }
      return {
        validRegex: regex,
      };
    }
    return {
      countryCode: 'MY',
      identityType: this.validateIdentityType(),
    };
  }

  render() {
    const { customer } = this.state;
    const { addressSettings, auth, t } = this.props;
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    const isMalaysia = auth && auth.company.countryCode.toUpperCase() === 'MY';
    const isIndonesia = auth && auth.company.countryCode.toUpperCase() === 'ID';
    const isVietnam = auth && auth.company.countryCode.toUpperCase() === 'VN';
    const isMalaysiaAddress = customer.country.toUpperCase() === 'MY';
    const mustValidTin = customer.identityTypeID === IDENTITY_TYPE_BRN;

    let tinValidation = [];
    if (isIndonesia) {
      tinValidation = [
        {
          validate: matchRegex,
          option: { validRegex: REGEX_NPWP_ID },
        },
      ];
    } else if (isMalaysia) {
      // For Malaysia, validation is optional unless tinRequired is true
      const tinRules = [
        {
          validate: matchRegex,
          option: { validRegex: REGEX_TIN_VALID },
        },
      ];
      if (this.state.tinRequired) {
        tinRules.unshift(required);
      }
      tinValidation = tinRules;
    }

    const inputs = enabledAddressSettings.map((as, idx) => {
      const key = _.camelCase(as.columnName);
      let addressLabel = as.label.toLowerCase();
      let isRequired = as.required;
      const validations = [{
        validate: stringLength,
        option: {
          max: 256,
        },
      }];

      // When company is Vietnam: apply country-dependent logic for state field
      if (isVietnam && addressLabel === 'state') {
        if (isMalaysiaAddress) {
          // Malaysia selected: keep as "State", required
          isRequired = true;
        } else {
          // Non-Malaysia selected: change to "City/Province", optional
          addressLabel = 'cityOrProvince';
          isRequired = false;
        }
      } else if (isVietnam && addressLabel === 'city' && !isMalaysiaAddress) {
        addressLabel = 'ward';
        isRequired = false;
      } else if (isVietnam && addressLabel === 'postcode' && !isMalaysiaAddress) {
        addressLabel = 'postalCode';
        isRequired = false;
      }

      if (isRequired) {
        validations.push(required);
      }
      const label = `${translateModels(t, addressLabel, 'project')}${isRequired ? '*' : ''}`;

      if (isMalaysiaAddress && as.label.toLowerCase() === 'state') {
        return (
          <AppForm.Validate
            key={idx}
            validation={isRequired ? [required] : null}
            ref={this.validation[key]}
            onChange={this.handleChange}
            validateLabel={addressLabel}
          >
            <Form.Select
              name={key}
              fluid
              options={STATES}
              placeholder={`${t('Select', { ns: TRANSLATION_FILES.translation })} ${label.toLowerCase()}`}
              label={label}
              search
              selectOnBlur={false}
              value={customer[key]}
            />
          </AppForm.Validate>
        );
      }

      return (
        <AppForm.Input
          key={idx}
          autoComplete="off"
          name={key}
          onChange={this.handleChange}
          placeholder={label}
          label={label}
          ref={this.validation[key]}
          validation={validations}
          value={customer[key]}
          validateLabel={addressLabel}
        />
      );
    });
    inputs.push(
      (<Form.Select
        key="inputs_region"
        label={translateModels(t, 'region', 'project')}
        name="region"
        placeholder={t('Select {{title}}', { title: translateModels(t, 'region', 'project') })}
        search
        fluid
        onChange={this.handleChange}
        value={customer.region}
        options={[]}
        noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
      />
      ), (
        <AppForm.Validate
          key="inputs_country"
          validation={[required]}
          ref={this.validation.country}
          onChange={(e, stateData) => {
            // Reset state input field
            const as = enabledAddressSettings.find(a => a.label.toLowerCase() === 'state');
            if (as) {
              const key = _.camelCase(as.columnName);
              if (customer[key]) {
                customer[key] = '';
                this.setState({ customer });
              }
            }
            this.handleChange(e, stateData);
          }}
          validateLabel={translateModels(t, 'country', 'customer')}
        >
          <Form.Select
            autoComplete="off"
            fluid
            name="country"
            options={SELECT_COUNTRIES}
            placeholder={`${t('Select Country')}*`}
            label={`${translateModels(t, 'country', 'customer')}*`}
            search
            selectOnBlur={false}
            value={customer.country}
            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
          />
        </AppForm.Validate>
      ),
    );
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column>
              <Form.Group widths="equal">
                <Form.Field>
                  <Form.Select
                    fluid
                    onChange={this.handleChange}
                    label={`${translateModels(t, 'identityTypeID', 'customer')}*`}
                    placeholder={`${translateModels(t, 'identityTypeID', 'customer')}*`}
                    name="identityTypeID"
                    options={this.state.identityTypeOpts.map(i => ({
                      ...i,
                      text: t(i.text, { ns: TRANSLATION_FILES.screens }),
                    }))}
                    selection
                    selectOnBlur={false}
                    value={customer.identityTypeID}
                    noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                  />
                </Form.Field>
                <Form.Field>
                  <AppForm.Input
                    name="identity"
                    disabled={customer.identityTypeID === ''}
                    // temporary remove validation
                    // validation={[required, {
                    //   validate: ValidateIdentity,
                    //   option: this.identityValidation(),
                    // }]}
                    ref={this.validation.identity}
                    onChange={this.handleChange}
                    validateLabel={translateModels(t, 'identity', 'customer')}
                    placeholder={this.getIdentityPlaceholder(customer.identityTypeID, customer.identityPresetLabel)}
                    label={this.getIdentityPlaceholder(customer.identityTypeID, customer.identityPresetLabel)}
                    type="text"
                    value={customer.identity}
                  />
                </Form.Field>
                {(isMalaysia || isIndonesia) && (
                  <Form.Field>
                    <TinFieldInput
                      isIndonesia={isIndonesia}
                      value={customer.taxIdentificationNo}
                      errMessage={this.state.tinMessage}
                      isLoading={this.state.validatingTin}
                      tinError={isMalaysia && this.state.tinError}
                      required={isMalaysia && mustValidTin && !customer.isForeignCompany}
                      ref={this.validation.taxIdentificationNo}
                      onChange={this.handleTinInput}
                      validation={tinValidation}
                      // readOnly={isMalaysia && this.state.tinFound}
                      identityType={customer.identityTypeID}
                      identityValue={customer.identity}
                    />
                  </Form.Field>
                )}
              </Form.Group>
              {
                isMalaysia && customer.identityTypeID === IDENTITY_TYPE_BRN && <Form.Group>
                  <Form.Field>
                    <div style={{ display: 'flex', justifyContent: 'start' }}>
                      <Checkbox
                        label={t('Foreign Company', { ns: TRANSLATION_FILES.screens })}
                        onChange={(e, d) => {
                          const setStateTin = d.checked ? FOREIGN_BUYER_GENERIC_TIN : '';
                          this.setState(prevState => ({
                            customer: {
                              ...prevState.customer,
                              taxIdentificationNo: setStateTin,
                              isForeignCompany: d.checked,
                            },
                          }), () => {
                            this.handleTinInput({ target: { value: d.checked ? this.state.customer.taxIdentificationNo : '', tinFound: false } });
                          });
                        }}
                        checked={this.state.customer.isForeignCompany}
                      />
                    </div>
                  </Form.Field>
                </Form.Group>
              }
              <Form.Group widths="equal">
                {
                  this.state.hideTitle ? null : (
                    <AppForm.Validate
                      validation={[required]}
                      ref={this.validation.title}
                      onChange={this.handleChange}
                      validateLabel={translateModels(t, 'title', 'customer')}
                    >
                      <Form.Select
                        name="title"
                        onChange={this.handleChange}
                        options={CUSTOMER_TITLES.map(i => ({
                          ...i,
                          text: t(i.text, { ns: TRANSLATION_FILES.constants }),
                        }))}
                        label={`${t('Select Title')}*`}
                        placeholder={`${t('Select Title')}*`}
                        search
                        selectOnBlur={false}
                        value={customer.title}
                        noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                      />
                    </AppForm.Validate>
                  )
                }
                <AppForm.Input
                  autoComplete="off"
                  name="name"
                  onChange={this.handleChange}
                  placeholder={`${t(customer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}*`}
                  label={`${t(customer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}*`}
                  ref={this.validation.name}
                  validation={[
                    required,
                    ...vnFullNameValidations(auth, customer.identityTypeID, t),
                  ]}
                  value={customer.name}
                  validateLabel={t(customer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <AppForm.Input
                  autoComplete="off"
                  name="preferredName"
                  onChange={this.handleChange}
                  placeholder={`${t(customer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}*`}
                  label={`${t(customer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}*`}
                  ref={this.validation.preferredName}
                  validation={
                    customer.identityTypeID === IDENTITY_TYPE_BRN
                      ? [required, ...vnPreferredNameValidations(auth, t)]
                      : [
                        required,
                        {
                          validate: stringLength,
                          option: {
                            max: 15,
                          },
                        },
                        ...vnPreferredNameValidations(auth, t),
                      ]
                  }
                  value={customer.preferredName}
                  validateLabel={t(customer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}
                />
                <AppForm.Input
                  autoComplete="off"
                  name="email"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'email', 'customer')}
                  label={translateModels(t, 'email', 'customer')}
                  validation={[email]}
                  ref={this.validation.email}
                  value={customer.email}
                  validateLabel={translateModels(t, 'email', 'customer')}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <AppForm.Validate
                  validation={[required]}
                  ref={this.validation.mobilePrefix}
                  onChange={this.handleChange}
                  validateLabel={translateModels(t, 'mobilePrefix', 'customer')}
                >
                  <Form.Select
                    name="mobilePrefix"
                    onChange={this.handleChange}
                    options={INTL_CALL_CODES}
                    label={translateModels(t, 'mobilePrefix', 'customer')}
                    search
                    selectOnBlur={false}
                    value={customer.mobilePrefix}
                    noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                  />
                </AppForm.Validate>
                <PhoneInput
                  autoComplete="off"
                  name="mobile"
                  onChange={this.handleChange}
                  label={customer.mobilePrefix === '60' ? `${translateModels(t, 'mobile', 'customer')}* (e.g. 196756118)` : `${translateModels(t, 'mobile', 'customer')}*`}
                  placeholder={customer.mobilePrefix === '60' ? `${translateModels(t, 'mobile', 'customer')}* (e.g. 196756118)` : `${translateModels(t, 'mobile', 'customer')}*`}
                  prefix={customer.mobilePrefix}
                  ref={this.validation.mobile}
                  type="tel"
                  validation={[required, {
                    validate: phoneNumber,
                    option: customer.mobilePrefix === 'other' ? {} : {
                      isMobile: true,
                      phonePrefix: customer.mobilePrefix,
                      validRegex: getPhoneValidRegex(
                        this.state.phoneValidationPresets,
                        customer.mobilePrefix,
                        'mobile',
                      ),
                    },
                  }]}
                  value={customer.mobile}
                  validateLabel={translateModels(t, 'mobile', 'customer')}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Select
                  name="phonePrefix"
                  onChange={this.handleChange}
                  options={INTL_CALL_CODES}
                  label={translateModels(t, 'phonePrefix', 'customer')}
                  search
                  selectOnBlur={false}
                  value={customer.phonePrefix}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
                <PhoneInput
                  autoComplete="off"
                  name="phone"
                  onChange={this.handleChange}
                  placeholder={customer.phonePrefix === '60' ? `${translateModels(t, 'phone', 'customer')} (e.g. 196756118)` : t('House/Office Phone')}
                  label={customer.phonePrefix === '60' ? `${translateModels(t, 'phone', 'customer')} (e.g. 196756118)` : t('House/Office Phone')}
                  prefix={customer.phonePrefix}
                  ref={this.validation.phone}
                  type="tel"
                  value={customer.phone}
                  validation={[{
                    validate: phoneNumber,
                    option: customer.phonePrefix === 'other' ? {} : {
                      phonePrefix: customer.phonePrefix,
                      validRegex: getPhoneValidRegex(
                        this.state.phoneValidationPresets,
                        customer.phonePrefix,
                        'phone',
                      ),
                    },
                  }]}
                  validateLabel={t('House/Office Phone')}
                />
              </Form.Group>
              {
                // group 2 inputs into one Form.Group
                // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                _.chunk(inputs, 2).map((p, idx) => (
                  <Form.Group widths="equal" key={`group_${idx}`}>
                    {p}
                  </Form.Group>
                ))
              }
              <Form.Group widths="equal">
                <AppForm.Input
                  autoComplete="off"
                  name="jobTitle"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'jobTitle', 'customer')}
                  label={translateModels(t, 'jobTitle', 'customer')}
                  value={customer.jobTitle}
                />
                <AppForm.Input
                  type="number"
                  autoComplete="off"
                  name="monthlyIncome"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'monthlyIncome', 'customer')}
                  label={translateModels(t, 'monthlyIncome', 'customer')}
                  ref={this.validation.monthlyIncome}
                  validation={[{
                    validate: numericRange,
                    option: {
                      min: 0,
                    },
                  }]}
                  value={customer.monthlyIncome}
                  validateLabel={translateModels(t, 'monthlyIncome', 'customer')}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Select
                  name="nationality"
                  onChange={this.handleChange}
                  options={SELECT_NATIONALITY}
                  label={translateModels(t, 'nationality', 'customer')}
                  placeholder={translateModels(t, 'nationality', 'customer')}
                  search
                  selectOnBlur={false}
                  selection
                  value={customer.nationality}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
                <InputBirthdate
                  date={customer.birthdate}
                  onSelectDay={this.handleBirthdateSelect}
                  label={translateModels(t, 'birthdate', 'customer')}
                  disabled={customer.identityTypeID === 4}
                />
              </Form.Group>
              {/* <Form.Group widths="equal">
                <Form.Select
                  name="race"
                  fluid
                  options={RACE}
                  onChange={this.handleChange}
                  placeholder={t('Select Race')}
                  label={translateModels(t, 'race', 'customer')}
                  search
                  selectOnBlur={false}
                  value={customer.race}
                />
                <AppForm.Input
                  autoComplete="off"
                  disabled={customer.race.toUpperCase() !== 'Others'.toUpperCase()}
                  fluid
                  name="raceOther"
                  onChange={this.handleChange}
                  placeholder={t('Fill in your Race')}
                  label={translateModels(t, 'raceOther', 'customer')}
                  value={customer.raceOther}
                  validateLabel={translateModels(t, 'raceOther', 'customer')}
                  ref={this.validation.raceOther}
                  validation={customer.race.toUpperCase() === 'Others'.toUpperCase() ? [required] : null}
                />
              </Form.Group> */}
              {/* <Form.Group widths="equal">
                <Form.Select
                  name="bumi"
                  fluid
                  options={BUMI.map(o => ({
                    ...o,
                    text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                  }))}
                  label={translateModels(t, 'bumi', 'customer')}
                  onChange={this.handleChange}
                  placeholder={t('Select Bumiputera Status')}
                  search
                  selectOnBlur={false}
                  value={customer.bumi}
                />
              </Form.Group> */}
              <Form.Group widths="equal">
                <Form.Select
                  name="gender"
                  onChange={this.handleChange}
                  options={GENDER.map(o => ({
                    ...o,
                    text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                  }))}
                  label={translateModels(t, 'gender', 'customer')}
                  placeholder={t('Select Gender')}
                  search
                  selectOnBlur={false}
                  selection
                  value={customer.gender}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
                <Form.Select
                  name="maritalStatus"
                  onChange={this.handleChange}
                  options={MARITAL_STATUS.map(o => ({
                    ...o,
                    text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                  }))}
                  label={translateModels(t, 'maritalStatus', 'customer')}
                  placeholder={t('Select Marital Status')}
                  search
                  selectOnBlur={false}
                  selection
                  value={customer.maritalStatus}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <AppForm.Input
                  autoComplete="off"
                  name="emergencyContactName"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'emergencyContactName', 'customer')}
                  label={translateModels(t, 'emergencyContactName', 'customer')}
                  value={customer.emergencyContactName}
                />
                <AppForm.Input
                  autoComplete="off"
                  name="emergencyContactRelation"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'emergencyContactRelation', 'customer')}
                  label={translateModels(t, 'emergencyContactRelation', 'customer')}
                  value={customer.emergencyContactRelation}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <AppForm.Validate
                  ref={this.validation.emergencyContactMobilePrefix}
                  onChange={this.handleChange}
                  validateLabel={translateModels(t, 'emergencyContactMobilePrefix', 'customer')}
                >
                  <Form.Select
                    label={translateModels(t, 'emergencyContactMobilePrefix', 'customer')}
                    name="emergencyContactMobilePrefix"
                    onChange={this.handleChange}
                    options={INTL_CALL_CODES}
                    search
                    selectOnBlur={false}
                    value={customer.emergencyContactMobilePrefix}
                    noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                  />
                </AppForm.Validate>
                <PhoneInput
                  autoComplete="off"
                  label={translateModels(t, 'emergencyContactMobile', 'customer')}
                  name="emergencyContactMobile"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'emergencyContactMobile', 'customer')}
                  prefix={customer.emergencyContactMobilePrefix}
                  ref={this.validation.emergencyContactMobile}
                  type="tel"
                  validation={[{
                    validate: phoneNumber,
                    option: customer.emergencyContactMobilePrefix === 'other' ? {} : {
                      isMobile: true,
                      phonePrefix: customer.emergencyContactMobilePrefix,
                      validRegex: getPhoneValidRegex(
                        this.state.phoneValidationPresets,
                        customer.emergencyContactMobilePrefix,
                        'mobile',
                      ),
                    },
                  }]}
                  value={customer.emergencyContactMobile}
                  validateLabel={translateModels(t, 'emergencyContactMobile', 'customer')}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <AppForm.Input
                  autoComplete="off"
                  label={translateModels(t, 'emergencyContactEmail', 'customer')}
                  name="emergencyContactEmail"
                  type="email"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'emergencyContactEmail', 'customer')}
                  validation={[email]}
                  ref={this.validation.emergencyContactEmail}
                  value={customer.emergencyContactEmail}
                />
                <AppForm.Input
                  autoComplete="off"
                  name="emergencyContactIdentity"
                  onChange={this.handleChange}
                  placeholder={translateModels(t, 'emergencyContactIdentity', 'customer')}
                  label={translateModels(t, 'emergencyContactIdentity', 'customer')}
                  value={customer.emergencyContactIdentity}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.TextArea
                  label={translateModels(t, 'internalRemark', 'customer')}
                  placeholder={translateModels(t, 'internalRemark', 'customer')}
                  name="internalRemark"
                  value={customer.internalRemark}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.customer,
  TRANSLATION_FILES.models.project,
], { withRef: true })(CustomerForm);



// WEBPACK FOOTER //
// ./src/containers/Customers/Form.jsx